import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { ClientImage } from "./ClientsSection";
import { twMerge } from "tailwind-merge";

export const ShortClients = (props: { className?: string }) => {
  const clients: Record<string, { name: string; link: string; image: string }> =
    useStaticQuery(graphql`
      query ShortClientsQuery {
        bepower: clientsJson(jsonId: { eq: "bepower" }) {
          name
          link
          image
        }
        sailsquare: clientsJson(jsonId: { eq: "sailsquare" }) {
          name
          link
          image
        }
        memorabid: clientsJson(jsonId: { eq: "memorabid" }) {
          name
          link
          image
        }
        mechit: clientsJson(jsonId: { eq: "mechit" }) {
          name
          link
          image
        }
        ictc: clientsJson(jsonId: { eq: "ictc" }) {
          name
          link
          image
        }
      }
    `);

  const clientsArray = Object.keys(clients).map((k) => clients[k]);

  return (
    <div
      className={twMerge(
        "w-full flex justify-around items-center flex-wrap gap-x-12 md:gap-x-24 lg:gap-x-12 gap-y-8",
        props.className,
      )}
    >
      {clientsArray.map((c, i) => (
        <ClientImage key={`a-${i}`} size="sm" {...c} className="shrink-0" />
      ))}
    </div>
  );
};
